/* eslint-disable no-unused-vars */
import React, { memo } from 'react';
import { getDayMonthYear } from 'utils';
import * as S from './DateRangeInput.styled';
import { Calendar, CalendarDropDown } from 'assets/icons';
import PropTypes from 'prop-types';
import { casesForTypes } from '../todayBtns/TodayBtns';

const pickerType = {
  Custom: 'Custom',
  Today: 'Today',
  Yesterday: 'Yesterday',
  'This Week': 'This Week',
  'This Month': 'This Month',
  'Last 7 Days': 'Last 7 Days',
  'Last 14 Days': 'Last 14 Days',
  'Last Month': 'Last 30 Days',
  'Last Full Month': 'Last Month',
};

export const DateRangeInput = memo(function DateRangeInput({
  typeOfCalendar$,
  startDate$,
  endDate$,
  isCalendarOpen$,
}) {
  const handleOpen = (e) => {
    e.preventDefault();
    isCalendarOpen$.value = !isCalendarOpen$.value;
  };

  return (
    <S.Container
      className='dateRangeCustomInput'
      onClick={handleOpen}
      isOpen={isCalendarOpen$.value}
    >
      <S.LeftIcon>
        <Calendar className='calendarIcon' style={{ width: 22, height: 22, fill: '#3B89F6' }} />
      </S.LeftIcon>
      <S.TypeName>{pickerType[typeOfCalendar$.value]}</S.TypeName>
      <S.Date>{getDayMonthYear(startDate$.value)}</S.Date>
      <S.Date>{endDate$.value ? `\u2014 \u00A0${getDayMonthYear(endDate$.value)}` : ''}</S.Date>
      <S.RightIcon isOpen={isCalendarOpen$.value}>
        <CalendarDropDown />
      </S.RightIcon>
    </S.Container>
  );
});

DateRangeInput.displayName = 'DateRangeInput';

DateRangeInput.propTypes = {
  // handleOpen: PropTypes.func.isRequired,
  typeOfCalendar$: PropTypes.shape({
    value: PropTypes.oneOf([...casesForTypes, 'Custom']),
  }).isRequired,
  startDate$: PropTypes.shape({
    value: PropTypes.instanceOf(Date).isRequired,
  }),
  endDate$: PropTypes.shape({
    value: PropTypes.instanceOf(Date),
  }),
  isCalendarOpen$: PropTypes.shape({
    value: PropTypes.bool.isRequired,
  }),
};
